import parseInt from "./component-library109.mjs";
import padStart from "./component-library110.mjs";
import InputWrapper from "./component-library17.mjs";
import LabeledInput from "./component-library16.mjs";
import SelectInput from "./component-library24.mjs";
import "./component-library111.mjs";
import normalizeComponent from "./component-library81.mjs";
function buildOption(value) {
  const label = padStart(value.toString(), 2, "0");
  return { label, value };
}
function emptyDate() {
  return { day: null, month: null, year: null };
}
function getDateFromString(value) {
  if (!value)
    return emptyDate();
  const [year, month, day] = value.split("-").map(parseInt);
  return { day, month, year };
}
const DAYS = Array.from({ length: 31 }, (_, i) => buildOption(i + 1));
const MONTHS = Array.from({ length: 12 }, (_, i) => buildOption(i + 1));
const _sfc_main = {
  components: {
    SelectInput,
    InputWrapper
  },
  mixins: [LabeledInput],
  props: {
    value: {
      type: String,
      default: null
    },
    minYear: {
      type: Number,
      default: 1900
    },
    maxYear: {
      type: Number,
      default: () => (/* @__PURE__ */ new Date()).getFullYear()
    }
  },
  idPrefix: {
    type: String
  },
  emits: ["input"],
  data() {
    return {
      options: {
        day: DAYS,
        month: MONTHS
      },
      date: emptyDate()
    };
  },
  computed: {
    dateIsPresent() {
      return this.date.day && this.date.month && this.date.year;
    },
    dateString() {
      if (!this.dateIsPresent)
        return null;
      const day = padStart(this.date.day.toString(), 2, "0");
      const month = padStart(this.date.month.toString(), 2, "0");
      return `${this.date.year}-${month}-${day}`;
    },
    availableYears() {
      const yearData = [];
      for (let count = this.maxYear; count >= this.minYear; count -= 1) {
        yearData.push(count);
      }
      return yearData;
    }
  },
  watch: {
    value(value) {
      this.date = getDateFromString(value);
    }
  },
  created() {
    this.date = getDateFromString(this.value);
  },
  methods: {
    onSelect() {
      this.$emit("input", this.dateString);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("InputWrapper", _vm._b({ staticClass: "date-input", attrs: { "id": `${_vm.inputId}-date-day` }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("div", { staticClass: "date-input__wrapper" }, [_c("SelectInput", { attrs: { "id": `${_vm.inputId}-date-day`, "autocomplete": "bday-day", "name": "bday-day", "options": _vm.options.day, "prompt": "Tag", "value": _vm.date.day, "display-error-message": false, "select-class": _vm.inputClass, "disabled": _vm.disabled }, on: { "input": _vm.onSelect }, model: { value: _vm.date.day, callback: function($$v) {
      _vm.$set(_vm.date, "day", _vm._n($$v));
    }, expression: "date.day" } }), _c("SelectInput", { attrs: { "id": `${_vm.inputId}-date-month`, "options": _vm.options.month, "autocomplete": "bday-month", "name": "bday-month", "prompt": "Monat", "label": "Geburtsmonat", "label-class": "sr-only", "value": _vm.date.month, "display-error-message": false, "select-class": _vm.inputClass, "disabled": _vm.disabled }, on: { "input": _vm.onSelect }, model: { value: _vm.date.month, callback: function($$v) {
      _vm.$set(_vm.date, "month", _vm._n($$v));
    }, expression: "date.month" } }), _c("SelectInput", { attrs: { "id": `${_vm.inputId}-date-year`, "autocomplete": "bday-year", "name": "bday-year", "label": "Geburtsjahr", "label-class": "sr-only", "options": _vm.availableYears, "prompt": "Jahr", "value": _vm.date.year, "display-error-message": false, "select-class": _vm.inputClass, "disabled": _vm.disabled }, on: { "input": _vm.onSelect }, model: { value: _vm.date.year, callback: function($$v) {
      _vm.$set(_vm.date, "year", _vm._n($$v));
    }, expression: "date.year" } })], 1)];
  }, proxy: true }]) }, "InputWrapper", _vm.inputWrapperProps, false));
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "f9d133c5",
  null,
  null
);
const dateInput = __component__.exports;
export {
  dateInput as default
};
